import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { ProgressBar } from 'primereact/progressbar';
import { ContaAzulService } from '../../service/ContaAzulService';

export function ContaAzulCallback(props) {

    const history = useHistory();
    const code = window.location.search.split("?")[1].split("&")[0].split("=")[1];
    const ca_returnURL = localStorage.getItem("ca_returnURL");
    const ca_clientIdAndSecretSha = localStorage.getItem("ca_clientIdAndSecretSha");  

    useEffect(async () => {
        try {
            console.log(code, ca_clientIdAndSecretSha, ca_returnURL);       
            const contaazulservice = new ContaAzulService();
            await contaazulservice.setup({
                code,
                returnURL: ca_returnURL,
                sha: ca_clientIdAndSecretSha
            });
            localStorage.setItem("ca_return", "1");
        } catch (error) {
            localStorage.setItem("ca_return", "0");
            localStorage.setItem("ca_error", JSON.stringify(error));
        }
        
        const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
        if(loggedInUser.client && !loggedInUser.client.use_custom_url){
            window.location.href = '/' + loggedInUser.client.shortcode + '/config';
        }
        else{
            window.location.href = '/config';
        }

    }, []);

    return (<>
        <ProgressBar mode="indeterminate"/> 
    </>    );
}